import { Dialog } from '@mui/material';
import loadingIcon from 'assets/icons/loading.svg';
import { useSelector } from 'react-redux';
import { IStore } from 'v3/data/store';
import { Container, dialogPaperStyle } from './styles';

export default function Loading() {
  return (
    <Container>
      <img src={loadingIcon} alt="Loading" />
    </Container>
  );
}

export const LoadingGlobal = () => {
  const loading = useSelector((store: IStore) => store.loading);

  return (
    <Dialog
      fullScreen
      transitionDuration={0}
      open={loading.active}
      PaperProps={{
        style: dialogPaperStyle,
      }}
      sx={{ zIndex: 2000 }}
    >
      <Container>
        <img src={loadingIcon} alt="Loading" />
      </Container>
    </Dialog>
  );
};
